// extracted by mini-css-extract-plugin
module.exports = {"Container":"Checkbox_Container__LyG0q","Input":"Checkbox_Input__MbHM0","Label":"Checkbox_Label__iK0jd"};